import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";

import {KaitoriyaConfig} from "../config/kaitoriya.config";
import {DataService, OrientDBCollectionView} from "@cosbeni/database";

@Component({
    selector: 'cj-admin-master',
    templateUrl: 'master-management.component.html',
})

export class MasterManagementComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('masterGrid') masterGrid: wjcGrid.FlexGrid;
    masters: OrientDBCollectionView;
    vertexes: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService) {
        this.masters = new OrientDBCollectionView(dataService, KaitoriyaConfig.DATABASE, "SELECT FROM AP_Master", "AP_Master", "", 0, 100, true, true, false)
        this.masters.url = KaitoriyaConfig.SERVER_URL;
        this.masters.tokenName = KaitoriyaConfig.DATABASE + "_token";
    }

    ngOnInit() {
        this.masters.currentChanged.addHandler(this.onCurrentChanged, this);
        this.masters.filterOnServer = true;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

